import React from 'react'
import { Label } from 'semantic-ui-react'

export default function StatusLabel(props) {
  return <Label {...props} style={{ whiteSpace: 'nowrap' }} />
}

StatusLabel.defaultProps = {
  color: 'grey',
  size: 'mini',
}
